import { useState, useEffect, useCallback } from 'react'
import classNames from 'classnames'
import styles from './Toast.module.scss'

export type ToastProps = {
  message: string
  isVisible: boolean
  onClose?: () => void
  duration?: number
}

const Toast = ({ message, isVisible, onClose, duration = 7000 }: ToastProps) => {
  const [shouldRender, setShouldRender] = useState(false)
  const [animateIn, setAnimateIn] = useState(false)

  const handleClose = useCallback(() => {
    setAnimateIn(false)
    // Wait for animation to complete before removing from DOM
    setTimeout(() => {
      setShouldRender(false)
      onClose?.()
    }, 300)
  }, [onClose])

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true)
      // Trigger fade in animation
      const timer = setTimeout(() => {
        setAnimateIn(true)
      }, 50)

      // Auto close after duration
      const closeTimer = setTimeout(() => {
        handleClose()
      }, duration)

      return () => {
        clearTimeout(timer)
        clearTimeout(closeTimer)
      }
    }
  }, [isVisible, duration, handleClose])

  if (!shouldRender) return null

  return (
    <div
      className={classNames(styles.toast, {
        [styles.visible]: animateIn,
      })}
    >
      <p className={styles.message}>{message}</p>
    </div>
  )
}

Toast.displayName = 'Toast'

export default Toast
